export default "__VITE_ASSET__BQLBIRtz__";